import { Component, Input, ChangeDetectionStrategy, Injector } from '@angular/core'
import { Store } from '@ngrx/store'
import { NavController } from 'ionic-angular'
import { UIEventHub } from '../../../services/event.service'
import { ActionCreator } from '../../../services/action.service'
import { ViewModel } from '../../../view-model'
import { BaseWidget } from '../../base-widget'
import { ILegend } from '@ar2/common';
/**
 * グラフグループ
 *【オプションリスト:options:{graph_key:string, graph_option:string}[]】
 *【選択値:selectedValue:string】
 *【表示単位:displayUnit:number】
 *【凡例:legends:ILegend[]】
 * @author nabla2.metamodel.generator
 */
@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-graph-group',
  templateUrl: './graph-group.html',
  styles: [`
    .capagraph-list {
      max-height: 55vh;
      overflow-y: auto;
    }
    .chart {
      display: inline-block;
      height: 50vh;
      padding: 5px;
      width: calc(100% / 3);
    }
    sg-fr-echarts canvas {
      cursor: pointer;
    }
  `]
})
export class GraphGroup extends BaseWidget {
  /**
   * 選択値の表示モデルパス
   */
  @Input() viewModelPath:string

  /**
   * 選択値に対する精査エラー
   */
  @Input() errorMessages:{modelPath:string, message:string}[]

  /**
   * オプションリスト
   */
  @Input() options:{graph_key:string, graph_option:string}[]

  /**
   * 選択値
   */
  @Input() selectedValue:string

  /**
   * 表示単位
   */
  @Input() displayUnit:number

  /**
   * 凡例
   */
  @Input() legends:ILegend[]

  /**
   * コンストラクタ
   * @param navCtrl 画面遷移管理サービス
   * @param store Reduxストア
   */
  constructor(
    public navCtrl: NavController,
    public store: Store<{viewModel:ViewModel}>,
    public eventHub: UIEventHub,
    public actionCreator: ActionCreator,
    public injector: Injector,
  ) {
    super(injector)
  }
  /**
   * このコンポーネントの状態をバインドされた表示項目の状態に反映する。
   * @param event イベント
   */
  update(event:Event) {
    const node = <HTMLFormElement>event.target
    const value = node.value
    this.store.dispatch(this.actionCreator.updateViewModel(
      this.viewModelPath,
      (m) => value,
      {id:this.id, type:event.type, source:event},
      `update by ${this.id}`,
    ))
    this.on(event)
  }
}


// WEBPACK FOOTER //
// ./src/widgets/graph/graph-group/graph-group.component.ts